import {React,useState} from 'react';
import { Link } from 'react-router-dom';  // Import Link from react-router-dom
import { 
  HomeOutlined, 
  AppstoreAddOutlined, 
  AppstoreOutlined, 
  CodeOutlined, 
  UsergroupAddOutlined, 
  TeamOutlined, 
  BranchesOutlined, 
  MailOutlined, 
  EnvironmentOutlined, 
  MenuOutlined
} from '@ant-design/icons';  // Importing the Ant Design icons
import './sidebar.css';
import { Menu, Tooltip } from 'antd';
const items = [
  {
    key: 'mail',
    icon: <MailOutlined />,
  },
  {
    key: 'app',
    icon: <AppstoreOutlined />,
  },
]


const Sidebar = () => {
  const [collapsed, setCollapsed] = useState(false);

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };
  return (
    <>
    <div id="mySidenav" className="sidenav">
      <Tooltip placement="left" title="Home">
      <Link to="/" id="home">
        <HomeOutlined style={{ fontSize: '1.5rem' }} /> 
      </Link>
      </Tooltip>
      <Tooltip placement="left" title="Farm Master">
      <Link to="/farmmaster" id="farm-master">
        <AppstoreOutlined style={{ fontSize: '1.5rem' }} /> 
      </Link>
      </Tooltip>
      <Tooltip placement="left" title="Maintain Ease">
      <Link to="/maintainease" id="maintain-ease">
        <AppstoreOutlined style={{ fontSize: '1.5rem' }} /> 
      </Link>
      </Tooltip>
      <Tooltip placement="left" title="My HMS">
      <Link to="/mhms" id="mhms">
        <AppstoreOutlined style={{ fontSize: '1.5rem' }} /> 
      </Link>
      </Tooltip>
      <Tooltip placement="left" title="Off To On">
      <Link to="/offtoon" id="off-toon">
        <AppstoreOutlined style={{ fontSize: '1.5rem' }} /> 
      </Link>
      </Tooltip>
      <Tooltip placement="left" title="Post Sales Connect">
      <Link to="/postsalesconnect" id="post-sales-connect">
        <CodeOutlined style={{ fontSize: '1.5rem' }} /> 
      </Link>
      </Tooltip>
      <Tooltip placement="left" title="Property Management">
      <Link to="/propertymanagement" id="property-management">
        <AppstoreOutlined style={{ fontSize: '1.5rem' }} /> 
      </Link>
      </Tooltip>
      <Tooltip placement="left" title="Swap Kart">
      <Link to="/swapkart" id="swap-kart">
        <AppstoreOutlined style={{ fontSize: '1.5rem' }} /> 
      </Link>
      </Tooltip>
      <Tooltip placement="left" title="Unified Corporate Reports">
      <Link to="/ucreports" id="uc-reports">
        <AppstoreOutlined style={{ fontSize: '1.5rem' }} /> 
      </Link>
      </Tooltip>
      <Tooltip placement="left" title="Venue Bookings">
      <Link to="/venuebookings" id="venue-bookings">
        <AppstoreOutlined style={{ fontSize: '1.5rem' }} /> 
      </Link>
      </Tooltip>
    </div>




</>
  );
};

export default Sidebar;
